import React from 'react';

import Alert from 'spa/Components/Alert';
import EnvSplit from 'spa/Components/EnvSplit';
import {withI18n} from 'spa/Components/Context';
import PageLoading, {PageLoadingTitle, PageLoadingSubtitle, PageLoadingLine} from 'spa/Components/PageLoading';
import DocumentMeta from 'spa/Components/DocumentMeta';
import { BOOKING_BASE_URL } from 'utils/constants';
import Go from '../../Components/Go';

// import {CLASS_BOOKING_ROUTE} from 'utils/constants';

const BookingPage = withI18n((props, {i18n}) => {
  const {route: {path} = {path: ''}} = props;

  return (
    <EnvSplit
      server={() => (
        <div className="container gray full-height">
          <DocumentMeta meta={{name: {robots: 'noindex'}}} />
          <div className="js-only">
            <PageLoading>
              <PageLoadingTitle />
              <PageLoadingSubtitle className="show-desktop" />
              <PageLoadingLine />
              <PageLoadingLine />
              <PageLoadingLine />
            </PageLoading>
          </div>
          <div className="noscript">
            <Alert
              type="error"
              title={i18n._x('Javascript required', 'Booking flow')}
              text={i18n._x('You need to turn on javascript in your browser in order to be able to book.', 'Booking flow')}
            />
          </div>
        </div>
      )}
      browser={() =>
        // TODO classes - are we adding
        // const Booking = require('./Booking').default; // eslint-disable-line global-require
        // const Booking = path === CLASS_BOOKING_ROUTE ? require('./Classes').default : require('./Booking').default; // eslint-disable-line global-require
        (
          // TODO !! add logic in this component to check for existing basket then redirect to correct place
          <Go
            to={{
              pathname: `/${i18n.lc}/${BOOKING_BASE_URL}/services`,
            }} />
        )
      }
    />
  );
});

export default BookingPage;



// WEBPACK FOOTER //
// ./spa/Pages/BookingNext/index.jsx